module.exports = __webpack_public_path__ + "img/icon_side.030b58c8.svg";